import React from 'react';
import { SectionWrapper } from '../components/ui/SectionWrapper';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { ArrowRight, Clock, Search } from 'lucide-react';
import { Link } from 'react-router-dom';
import { guides, categories } from '../data/guides';
export function GuidesListPage() {
  return <div className="bg-slate-50 min-h-screen pb-20" data-id="element-385">
      {/* Header */}
      <div className="bg-white border-b border-slate-200 py-16 px-6" data-id="element-386">
        <div className="max-w-6xl mx-auto" data-id="element-387">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-388">All Guides</h1>
          <p className="text-lg text-slate-600 max-w-2xl mb-8" data-id="element-389">
            Browse our complete library of independent evaluations, comparisons,
            and industry analysis.
          </p>

          {/* Search */}
          <div className="max-w-xl relative" data-id="element-390">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" data-id="element-391" />
            <input type="text" placeholder="Search guides..." className="w-full pl-12 pr-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-392" />
          </div>
        </div>
      </div>

      <SectionWrapper background="muted" data-id="element-393">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-394">
          {guides.map(guide => {
          const category = categories.find(c => c.id === guide.category);
          return <Link key={guide.id} to={`/guide/${guide.id}`} className="block h-full" data-id="element-395">
                <Card hover className="flex flex-col h-full border-slate-200" data-id="element-396">
                  <div className="mb-4" data-id="element-397">
                    <span className="inline-block px-2 py-1 bg-slate-100 text-slate-600 text-xs font-semibold rounded uppercase tracking-wide" data-id="element-398">
                      {category?.label || 'Guide'}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-3 leading-snug" data-id="element-399">
                    {guide.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow" data-id="element-400">
                    {guide.description}
                  </p>
                  <div className="flex items-center justify-between pt-4 border-t border-slate-100 mt-auto" data-id="element-401">
                    <span className="flex items-center text-xs text-slate-400 font-medium" data-id="element-402">
                      <Clock className="w-3 h-3 mr-1" data-id="element-403" /> {guide.readTime}
                    </span>
                    <span className="text-sm font-medium text-teal-700 flex items-center group" data-id="element-404">
                      Read Guide{' '}
                      <ArrowRight className="ml-1 w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-405" />
                    </span>
                  </div>
                </Card>
              </Link>;
        })}
        </div>
      </SectionWrapper>
    </div>;
}